import { HttpService } from 'core/modules/network-service';
import { get, merge } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

// local dependencies
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberOrderDetail defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberOrderDetailService } from 'services/memberOrderDetail';
 *
 * // create service instance and send/cancel request
 * const memberOrderDetailService = new MemberOrderDetailService();
 * const result = await memberOrderDetailService.fetchData( '<user-id>' ); // fetch data
 * memberOrderDetailService.cancel(); // cancel an active request
 */
export class MemberOrderDetailService extends HttpService {

    // fetch call control widget data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

        // get ongoing callType info from the redux store
        const callType = get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null );

        // caller Type
        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        callId,
                        callType,
                        callerType
                    },
                } ),
            } );

            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const widgets = get( response, 'body.component.structure.widgets', [] );
            const navActions = get( response, 'body.component.structure.navActions', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    widgets: getVisibleItems( widgets, visibility ),
                    navActions: getVisibleItems( navActions, visibility ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
